/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 获取导航列表(启用)
   */
  getNavList: 'GET /nav/list',

  /**
   * 获取导航对应的权限点、数据权限点
   */
  getNavGrant: 'GET /nav/grant-list',

  /**
   * 获取导航列表(所有(管理端))
   */
  queryNavList: 'GET /nav/query',

  /**
   * 获取导航详情
   */
  getNav: 'GET /nav/{id}',

  /**
   * 删除导航
   */
  deleteNav: 'DELETE /nav/delete/{id}',
  /**
   * 添加导航
   */
  addNav: 'POST /nav/create',
  /**
   * 更新导航
   */
  updateNav: 'PATCH /nav/update',

  /**
   * 获取导航功能点
   */
  queryNavFunction: 'GET /nav/functions',

  /**
   * 更新功能点
   */
  updateNavFunction: 'POST /nav/function/update',

  /**
   * 获取导航功能点
   */
  queryNavDataScope: 'GET /nav/data-scopes',

  /**
   * 更新数据权限点
   */
  updateNavDataScope: 'POST /nav/data-scope/update'
}
